import "./Experience.css";

const SKILL_GROUPS = [
  {
    title: "Languages",
    items: ["Python", "TypeScript / JavaScript", "C#", "SQL"],
  },
  {
    title: "Backend",
    items: ["Django", "FastAPI", "Flask", ".NET", "REST APIs", "Microservices"],
  },
  {
    title: "Data & cloud",
    items: [
      "PostgreSQL",
      "MySQL",
      "SQL Server",
      "AWS (EC2, Lightsail)",
      "Docker",
      "GitHub Actions",
      "Linux",
    ],
  },
  {
    title: "Pipeline & ML",
    items: [
      "VFX / production automation",
      "Pytest",
      "Postman",
      "Git",
      "TensorFlow",
      "OCR",
    ],
  },
];

export default function Experience() {
  return (
    <section id="skills">
      <h5>Toolkit</h5>
      <h2>Tech stack</h2>
      <p className="section__lead">
        Skills from backend engineering, VFX pipeline tooling at PROXI, and project work
        — aligned with my resume.
      </p>

      <div className="container skills__container">
        {SKILL_GROUPS.map(({ title, items }) => (
          <div key={title} className="skills__group">
            <h3>{title}</h3>
            <ul className="skills__tags">
              {items.map((skill) => (
                <li key={skill} className="tag tag--skill">
                  {skill}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}
